import { z } from 'zod';
export const widgetTypeSchema = z.enum([
    'calendar',
    'invoice',
    'task',
    'budget',
    'receivable',
    'payable',
    'financial-health',
    'operating-income',
    'operating-expenses',
    'insurance',
    'unit',
    'rent-radar',
]);
//# sourceMappingURL=dashboard.js.map